import appLogo from "@/assets/images/app-logo-placeholder.svg";
import AppFrame from "@/components/AppFrame";
import { useUserContext } from "@/contexts";
import Auth from "@/pages/Auth";
import {
  Navigate,
  Outlet,
  Route,
  Routes as ReactRouterRoutes,
} from "react-router-dom";
import MatcherPage from "@/pages/MatcherPage";
import Settings from "@/pages/Settings";
import ImpersonatePage from "@/pages/Admin/Impersonate";

const Routes = () => {
  return (
    <ReactRouterRoutes>
      <Route element={<ProtectedRoutes />}>
        <Route element={<AppFrame logo={appLogo} />}>
          <Route index element={<Navigate to="home" />} />
          <Route path="home" element={<MatcherPage />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Route>
      <Route path="auth" element={<Auth />} />
      <Route path="admin/impersonate" element={<ImpersonatePage />} />
    </ReactRouterRoutes>
  );
};

const ProtectedRoutes = () => {
  const { user } = useUserContext();
  if (!user.accountName) return <Navigate to="/auth" />;

  return <Outlet />;
};

export default Routes;
